export const proposalFields = [
  {
    id: 1,
    value: "name",
    type: "string"
  },
  // {
  //   id: 2,
  //   value: "password",
  //   type: "password"
  // },
  {
    id: 3,
    value: "email",
    type: "email"
  },
  {
    id: 4,
    value: "valid_until",
    type: "date"
  },
  {
    id: 5,
    value: "last_name",
    type: "string"
  },
  {
    id: 6,
    value: "first_name",
    type: "string"
  },
  {
    id: 7,
    value: "middle_name",
    type: "string"
  },
  {
    id: 8,
    value: "company",
    type: "string"
  },
  {
    id: 9,
    value: "position",
    type: "string"
  }
];
